import { createContext } from 'react';

// Generic event payload coming from backend websocket
export interface ReceptionEvent {
  event?: string;
  event_type?: string;
  event_id?: string;
  entity?: string;
  entity_id?: number | string | null;
  action?: string;
  occurred_at?: string;
  origin?: string;
  payload?: Record<string, unknown>;
  invalidate_keys?: string[];
  toast?: { message?: string; type?: 'success' | 'info' | 'warning' | 'danger'; durationMs?: number } | null;
  student_id?: number;
  group_id?: number;
  request_id?: number;
  invoice_id?: number;
  task_id?: number;
  payment_id?: number;
  full_name?: string;
  source?: 'postgresql' | 'manual' | 'postgresql_trigger' | 'application';
  table?: string;
  record_id?: number | string | null;
  timestamp?: number | string;
  [k: string]: unknown
}

export interface RealtimeContextShape {
  subscribe: (cb: (ev: ReceptionEvent)=>void) => () => void;
  connectionState: 'connecting'|'open'|'closed'|'error'|'reconnecting';
  reconnect: () => void;
}

export const RealtimeContext = createContext<RealtimeContextShape | null>(null);

// Provider implementation moved to RealtimeProvider.tsx
